export var SubscriptionOwnerSystem;
(function (SubscriptionOwnerSystem) {
    SubscriptionOwnerSystem["Stripe"] = "stripe";
    SubscriptionOwnerSystem["Symon"] = "symon";
    SubscriptionOwnerSystem["Product"] = "product"; // internal owner system used to for subscriptionType
})(SubscriptionOwnerSystem || (SubscriptionOwnerSystem = {}));
//# sourceMappingURL=subscriptionOwnerSystem.js.map